// fancy_cart_2026.js – cooler/combo product helpers (requires fancy_cart.js for addProductsSerialized, updateCartCount)
// Load conditionally in product templates that use the fancy add-to-cart combo (e.g. product.cooler-2026)

// ********************************************* //
// HELPER FUNCTIONS                              //
// ********************************************* //

function addProductChecks(products, addto){
	console.log('addProductChecks() PRODUCTS:');
	console.log(products);
	$(products).each(function(){
		var product = {
			'id': $(this).val(),
			'quantity': 1,
			'properties': {
				'Add to': addto,
			}
		};
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			async: false,
			data: jQuery.param(product),
			dataType: 'json',
			error: function(){},
			success: function(){
				console.log('ADDED PRODUCT ID: '+product.id);
			},
			cache: false
		});
	});
}

// ********************************************* //
// PICKER COUNT                                  //
// ********************************************* //

function pickerCount(elems){
	let sum = 0;
	$(elems).each(function() {
		var isCheckbox = $(this).is(':checkbox');
		var isOption = $(this).is('option');
		if (isCheckbox || isOption) {
			sum += 1;
		} else {
			sum += Number($(this).val());
		}
	});
	return sum;
}

// ********************************************* //
// PROCESS ADDON SECTION (sauces, toppings, etc.)//
// selectedElements: jQuery set of option elements with data-vid, data-productname, val() = qty
// includedCount: number included in base price; over this = extra, pushed to productsToAdd
// Returns { attr: string, processed: number } for combo line item and validation
// ********************************************* //

function processAddonSection(selectedElements, includedCount, addto, productsToAdd, alertMessage) {
	var attr = '';
	var processed = 0;
	var count = pickerCount(selectedElements);

	if (includedCount > 0 && count < includedCount) {
		alert(alertMessage);
		return { attr: attr, processed: processed };
	}

	if (count >= includedCount) {
		$(selectedElements).each(function() {
			var isCheckbox = $(this).is(':checkbox');
			var isOption = $(this).is('option');
			
			// For checkboxes and standard options, value is often the variant ID, so we assume qty 1
			var rawVal = $(this).val();
			var vid = $(this).data('vid');
			var qty;
			
			if ((isCheckbox || isOption) && !vid) {
				// If vid is not set in data-vid, assume val() is the vid and qty is 1
				vid = rawVal;
				qty = 1;
			} else if (isCheckbox) {
				// Checkbox with data-vid
				qty = 1;
			} else {
				qty = parseInt(rawVal, 10) || 1;
			}
			
			var name = $(this).data('productname');

			if (processed + qty <= includedCount) {
				attr = attr + qty + ' x ' + name + ', ';
				processed = processed + qty;
			} else {
				var extraItem = {
					id: parseInt(vid, 10),
					quantity: parseInt(qty, 10),
					properties: { 'Add to': addto || "" }
				};
				if (processed >= includedCount) {
					processed = processed + qty;
				} else {
					var splitQty = includedCount - processed;
					var remainder = qty - splitQty;
					attr = attr + splitQty + ' x ' + name + ', ';
					extraItem.quantity = remainder;
					processed = processed + qty;
				}
				productsToAdd.items.push(extraItem);
			}
		});
		attr = attr.slice(0, -2);
	}
	return { attr: attr, processed: processed };
}

// ********************************************* //
// PRICE CENTS – ensure integer in cents for data-price
// ********************************************* //

function priceCents(val) {
	var p = parseInt(val, 10);
	return isNaN(p) ? 0 : p;
}

// ********************************************* //
// GET PRODUCT – load product by handle & render //
// displayType: 'select' | 'multi-picker' | 'checkbox'
// options: { pickerClass, wrapperExtraClass } for multi-picker
// All outputs include data-price (int, cents); missing → 0
// ********************************************* //

function getProduct(handle, containerSelector, displayType, showFeaturedImage, options) {
	options = options || {};
	var pickerClass = options.pickerClass || '';
	var wrapperExtraClass = options.wrapperExtraClass || '';

	var url = '/products/' + handle + '.js';
	console.log('LOAD ' + handle.toUpperCase());

	var excluded_ids = [16688035201122, 29700147478626, 30303556206690, 16688026714210, 31404839927906, 43802103382252, 43802103349484];

	$.ajax({
		type: 'GET',
		url: url,
		async: false,
		dataType: 'json',
		error: function(err) {
			console.log('GET PRODUCT ERROR: ' + handle);
			console.log(err);
		},
		success: function(data) {
			console.log(handle + ':', data.variants);
			var variant_image = data.featured_image;
			
			// Filter variants by availability and exclusion IDs
			var activeVariants = data.variants.filter(function(v) {
				if (!v.available) return false;
				if (options.excludeIds && options.excludeIds.includes(v.id)) return false;
				return true;
			});

			if (displayType === 'select') {
				var variantCount = activeVariants.length;
				$(activeVariants).each(function() {
					var price = priceCents(this.price);
					var optionImage = '';
					if (this.featured_image && this.featured_image.src) {
						optionImage = this.featured_image.src;
					} else if (variant_image) {
						optionImage = (typeof variant_image === 'string') ? variant_image : (variant_image.src || '');
					}
					var opt = "<option data-price='" + price + "' data-productname='" + this.title + "' data-image='" + optionImage + "' value='" + this.id + "'";
					if (variantCount === 1) { opt += " selected"; }
					var text = this.title;
					if (options.priceFormat === 'dash') {
						text += " — $" + (price / 100);
					} else if (options.priceFormat === 'plus') {
						text += " +$" + (price / 100);
					}
					opt += ">" + text + "</option>";
					$(containerSelector).append(opt);
				});
				return;
			}

			if (displayType === 'checkbox') {
				$(activeVariants).each(function() {
					var price = priceCents(this.price);
					var html = '<div class="option-checkbox">';
					if (showFeaturedImage && this.featured_image && this.featured_image.src) {
						html += '<div class="product-mini-preview-wrapper"><div class="product-mini-preview"><img src="' + this.featured_image.src + '" alt="' + this.title + '" /></div></div>';
					}
					html += '<input id="custom-option-' + this.id + '" class="option-checkbox-checkbox product-select-checkbox" type="checkbox" name="option-' + this.id + '" data-price="' + price + '" data-vid="' + this.id + '" data-productname="' + this.title + '" value="' + this.id + '" />';
					var text = this.title;
					if (options.priceFormat === 'dash') {
						text += " — $" + (price / 100);
					} else if (options.priceFormat === 'plus') {
						text += " +$" + (price / 100);
					}
					html += '<label class="cake-label-option-checkbox-label" for="custom-option-' + this.id + '">' + text + '</label></div>';
					$(containerSelector).append(html);
				});
				return;
			}

			if (displayType === 'multi-picker') {
				var optionsHtml = '<option value="" data-price="0" disabled selected>-</option>';
				for (var q = 0; q <= 6; q++) {
					optionsHtml += '<option value="' + q + '" data-vid="{{vid}}" data-price="{{price}}" data-productname="{{title}}">' + q + '</option>';
				}

				$(activeVariants).each(function() {
					var title = (this.title === 'Default Title' && this.name) ? this.name : this.title;
					var price = priceCents(this.price);
					var imgSrc = null;
					if (this.featured_image && this.featured_image.src) {
						imgSrc = this.featured_image.src;
						variant_image = this.featured_image;
					} else if (variant_image) {
						imgSrc = (typeof variant_image === 'string') ? variant_image : (variant_image.src || null);
					}
					var titleEsc = title.replace(/"/g, '&quot;').replace(/'/g, '&#39;');

					var selectHtml = optionsHtml
						.replace(/\{\{vid\}\}/g, this.id)
						.replace(/\{\{price\}\}/g, String(price))
						.replace(/\{\{title\}\}/g, titleEsc);

					var wrapperClass = 'variant-multipicker' + (wrapperExtraClass ? ' ' + wrapperExtraClass : '');
					var html = '<div id="multipicker-' + this.id + '" class="' + wrapperClass + '" data-vid="' + this.id + '">';
					html += '<div class="variant-multipicker-picker">';
					html += '<div class="variant-picker-title">' + title.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</div>';
					html += '<select name="multi-picker-' + titleEsc + '" class="product-multi-select-picker ' + pickerClass + ' product-select-multi-' + (data.handle || '') + '">' + selectHtml + '</select>';
					html += '</div></div>';

					$(containerSelector).append(html);

					if (showFeaturedImage && imgSrc) {
						$('#multipicker-' + this.id).prepend('<div class="product-mini-preview-wrapper"><div class="product-mini-preview"><img src="' + imgSrc + '" alt="' + titleEsc + '" /></div></div>');
					}
				});
			}
		},
		cache: false
	});
}

// ********************************************* //
// ADD TUB FLAVOURS (populate flavour selectors) //
// ********************************************* //

function addTubFlavours(elems, count) {
	let flavour_selector = '#'+elems;
	console.log('FLAVOUR-PICKER INSTANCE ID: '+flavour_selector);

	// *************************************************************
	// GET FLAVOURS
	// *************************************************************

	const pid = "party-cooler-4l-tub.js";

	$.ajax({
		type: 'GET',
		url: '/products/' + pid,
		async: false,
		dataType: 'json',
		error: function(error) {
			console.log('GET FLAVOURS ERROR:');
			console.log(error);
		},
		success: function(data) {
			console.log('GET FLAVOURS SUCCESS:');
			console.log(data);
			$(data.variants).each(function() {
				console.log('FLAVOUR '+this.title + ' ' + this.id + ' ' + this.available);
				let metas = variant_meta1[this.id];
				var fp = priceCents(this.price);
$(flavour_selector).append("<option id='option-"+count+"-"+this.id+"' class='filter-option option-"+count+"-"+this.id+"' data-vid='"+this.id+"' data-price='"+fp+"' data-productname='" + this.title + "' data-isdairy='" + metas.dairy + "' data-isvegan='" + metas.vegan + "' data-isgf='" + metas.gf + "' data-issf='" + metas.sf + "' data-isalcohol='" + metas.alcohol + "' data-isannato='" + metas.annato + "' data-isegg='" + metas.egg + "' data-ispea='" + metas.pea + "' data-iscorn='" + metas.corn + "' data-isnas='" + metas.nas + "' data-iscustard='" + metas.custard + "' data-issorbet='" + metas.sorbet + "' data-ishalal='" + metas.halal + "' data-iskosher='" + metas.kosher + "' data-iskosherp='" + metas.kosherp + "' data-image='" + metas.image + "' value='" + this.id + "'>" + this.title + "</option>");
			});
		},
		cache: false
	});

	// SORT OPTIONS ALPHABETICALLY
	let options_list = $(flavour_selector).find('option');
	options_list.sort(function(a, b) {
		return $(a).text().toLowerCase() > $(b).text().toLowerCase() ? 1 : -1;
	});
	$(flavour_selector).append(options_list);
	$(flavour_selector).find('option.flavour-option-hint').prependTo(flavour_selector);
	$(flavour_selector+' option:first').attr('selected','selected');
}
